<template lang="pug">
  v-card(v-if="form")
    v-card-title
      h2.card-title {{ 'base.edit_ingredient' | translate }}
    v-card-content
      v-select.mb-3(
        api-search
        label="base.type"
        :options="ingredientTypes"
        :value="form.ingredient_type && form.ingredient_type.id"
        @input="onTypeChange"
        @search="onIngredientTypeSearch")
      v-input.mb-3(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="form.name")
      //- v-select.mb-3(
        :label="$t('base.stock')"
        :options="stocks"
        v-model="form.stock.id")
      v-input.mb-3(
        :label="$t('base.dry_metter')"
        :hint="errorMessage('dry_metter')"
        :invalid="!!errorMessage('dry_metter')"
        type="number"
        min="0"
        max="100"
        v-model="form.dry_matter")
      v-switch.mb-3(
        :label="$t('history.ignore_in_reports')"
        v-model="form.ignored_in_report")
      v-switch(
        :label="$t('history.autoload')"
        v-model="form.auto_load")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onSubmit")
        | {{ 'base.save' | translate }}
      delete-btn(
        @delete="onDelete")
</template>

<script>
import api from '@/api'
// import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'CreateNewModal',

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  mixins: [formErrorsMixin],

  components: {
    DeleteBtn
  },

  data: () => ({
    form: null,
    ingredientTypes: [],
    loading: false,
    errors: {
      name: null
    }
  }),

  mounted () {
    this.form = {
      ...this.data
    }
    this.onIngredientTypeSearch()
    // this.loadStocks()
  },

  methods: {
    // ...mapActions('stocks', [
    //   'loadStocks'
    // ]),

    async onSubmit () {
      this.loading = true
      const { id, ...payload } = this.form

      this.checkValidData()

      if (this.errors.name === null) {
        const { errors } = await api.ingredients.updateById(id, payload)
        this.errors = errors
        if (!errors) {
          this.$emit('update')
          this.$emit('close')
        }
        this.loading = false
      }
    },
    checkValidData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
      }
    },

    async onIngredientTypeSearch (value = null) {
      const params = {
        name: value,
        limit: 2500
      }
      const { data } = await api.ingredienttypes.litelist(params)
      this.ingredientTypes = data
    },

    onTypeChange (id) {
      this.form.ingredient_type = { id }
      const type = this.ingredientTypes.find(item => item.id === id)
      if (type) {
        this.form.name = type.name
      }
    },

    async onDelete () {
      const { errors } = await api.ingredients.deleteById(this.form.id)
      if (!errors) {
        this.$emit('update')
      }
      this.$emit('close')
    }
  },

  // computed: {
  //   ...mapGetters('stocks', [
  //     'stocks'
  //   ])
  // }
}
</script>
